import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { IVisits } from '../Interfaces/IVisits';
import { MyApprovalsDetailsComponent } from './my-approvals-details/my-approvals-details.component';
import { MyApprovalsService } from '../services/myApprovals-service';
import { IMyApprovals } from '../Interfaces/IMyApprovals';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { RolesService } from '../services/roles-service';
import { IRoles } from '../Interfaces/IRoles';
import { IScreens } from '../Interfaces/IScreens';
import { RejectApprovalComponent } from './reject-approval/reject-approval.component';
import { IRejectApprovals } from '../Interfaces/IRejectApprovals';

declare var $: any;

interface MyApprovals {
  PKVisitByVisitors: number;
  fk_visitor_by_visit: number;
  fk_approver_area: number;
  fkApprover: number;
}

@Component({
  selector: 'my-approvals',
  templateUrl: './my-approvals.component.html',
  styles: [
  ]
})
export class MyApprovalsComponent implements OnInit {


  columns: Array<any> = [
    'selectcolumn',
    'pkvisit',
    'approverarea',
    'visittype',
    'strstartdatevisit',
    'strenddatevisit',
    'building',
    'activity',
    'areaproject',
    'sponsor',
    'strcreationdate',
    'employeecreatorname',
    'strlastupdated',
    'employeeupdatername',
    'namerecordstatus'
  ];
  displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
  disableButtonRedirectToSubcontracting: boolean = false;
  listData: Array<IMyApprovals> = [];
  listPKVisitByVisitors: number[] = [];
  loading = false;
  station: string = 'TABLE';
  hideButtonRedirectToSubcontracting: boolean = false;

  fk_visitor_by_visit: number;
  fk_approver_area: number;
  fkApprover: number;
  listRejectApprovals: Array<IRejectApprovals> = [];

  constructor(
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private router: Router,
    private myApprovalsService: MyApprovalsService,
    private notificationService: NotificationService,
    private translate: TranslateApplicationService,
    private rolesService: RolesService
  ) { }

  ngOnInit(): void {
    const component = this;
    $('.btnReload').click(function () {
      component.GetRoleUser();
		});
	  component.GetRoleUser();
  }

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  GetApprovalAreasByUser() {
    this.myApprovalsService.GetApprovalAreasByUser()
    .subscribe(
        (result: TransactionResult<IMyApprovals[]>) => {
          this.loading = false;
        if (result.success) {
          let existMRO = result.data.filter((element) => element.approverarea == 'MRO');
          if (existMRO.length > 0) {
            this.hideButtonRedirectToSubcontracting = false;
          } else {
            this.hideButtonRedirectToSubcontracting = true;
          }
        } else {
          this.loading = false;
          this.Alert("Error", "MYAPPROVALS.Error_retrieving_user_approval_areas");
        }
      }, (error: any) => {
        this.loading = false;
        this.ErrorAlert(error);
      }
    );
  }

  GetRequestByUser() {
    this.loading = true;
    this.listPKVisitByVisitors = [];
    this.listData = [];
    this.myApprovalsService
      .GetMyApprovals()
      .subscribe(
        (result: TransactionResult<IMyApprovals[]>) => {
          this.loading = false;
          if (result.success) {
            
            this.listData = result.data;
            this.listData.forEach(element => {
              element.strstartdatevisit = this.datePipe.transform(element.startdatevisit, "yyyy-MM-dd HH:mm:ss");
              element.strenddatevisit = this.datePipe.transform(element.enddatevisit, "yyyy-MM-dd HH:mm:ss");
              element.strcreationdate = this.datePipe.transform(element.creationdate, "yyyy-MM-dd HH:mm:ss");
              element.strlastupdated = this.datePipe.transform(element.lastupdated, "yyyy-MM-dd HH:mm:ss");
            });
          }else {
            this.loading = false;
            this.Alert("Error", "MYAPPROVALS.Failed_to_retrieve_user_approvals");
          }
        }, (error: any) => {
          this.loading = false;
          this.ErrorAlert(error);
        }
      );
  }

  GetRoleUser() {
    this.rolesService.EmployeeHasPermissionToScreen('My approvals').subscribe(
			(result: TransactionResult<IScreens[]>) => {
				this.loading = false;
				if (result.success) {
					if (result.data == null || result.data.length == 0)
						this.router.navigateByUrl('/main/without-permission');
				}
			},
			(error: any) => { this.ErrorAlert(error); this.loading = false; },
		);
    this.rolesService.GetRoleByUser()
      .subscribe(
        (result: TransactionResult<IRoles>) => {
            this.GetRequestByUser();
        }, (error: any) => {
          this.loading = false;
          this.ErrorAlert(error);
        }
    );
    
    this.GetApprovalAreasByUser();
  }

  View(item: IVisits) {
    const dialogRef = this.dialog.open(MyApprovalsDetailsComponent, {
      data: item,
    });
    dialogRef.afterClosed().subscribe((result) => { this.GetRoleUser(); });
  }

  Approve(item: IMyApprovals) {
    this.loading = true;
    if (this.listPKVisitByVisitors.length > 0) {
      
      this.listPKVisitByVisitors.forEach(elementVisit => {
        let approvalInformation = this.listData.filter(element => element.fk_visitor_by_visit == elementVisit)[0];
          
        this.fk_visitor_by_visit = approvalInformation.fk_visitor_by_visit;
        this.fk_approver_area = approvalInformation.fk_approver_area;
        this.fkApprover = approvalInformation.fkApprover;

        this.myApprovalsService
          .ApproveVisitByVisitor(this.listPKVisitByVisitors, this.fk_visitor_by_visit, this.fk_approver_area, this.fkApprover)
          .subscribe(
            (result: TransactionResult<boolean>) => {
              this.loading = false;
              if (result.success) {
                this.Alert("Success", "MYAPPROVALS.VISIT_APPROVED"); 	
                this.GetRequestByUser();
              } else {
                this.loading = false;
                this.Alert("Error", "MYAPPROVALS.Failed_to_approve");
              }
            },
            (error: any) => { this.ErrorAlert(error); this.loading = false; }
          );
      });
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('MYAPPROVALS.Must_select_request'),
        shown: true
      });
    }
  }

  Reject(item: IMyApprovals) {

    if (this.listPKVisitByVisitors.length > 0) {

      this.listPKVisitByVisitors.forEach(elementVisit => {
        let approvalInformation = this.listData.filter(element => element.fk_visitor_by_visit == elementVisit)[0];

        let Visitor: IRejectApprovals = {
          listPKVisitByVisitors: elementVisit,
          fk_visitor_by_visit: approvalInformation.fk_visitor_by_visit,
          fk_approver_area: approvalInformation.fk_approver_area,
          fkApprover: approvalInformation.fkApprover
        }

        this.listRejectApprovals.push(Visitor);
      });

      const dialogRef = this.dialog.open(RejectApprovalComponent, {
        data: this.listRejectApprovals
      });
      dialogRef.afterClosed().subscribe((result) => { this.GetRequestByUser(); this.listRejectApprovals = []; });
    }else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('MYAPPROVALS.Must_select_request'),
        shown: true
      });
    }
  }

  RedirectToSubscontrating(item: IMyApprovals) {
    this.loading = true;
    if (this.listPKVisitByVisitors.length > 0) {
      
       this.listPKVisitByVisitors.forEach(elementVisit => {
        let approvalInformation = this.listData.filter(element => element.fk_visitor_by_visit == elementVisit)[0];
          
        this.fk_visitor_by_visit = approvalInformation.fk_visitor_by_visit;
        this.fk_approver_area = approvalInformation.fk_approver_area;
        this.fkApprover = approvalInformation.fkApprover;

        this.myApprovalsService
          .RedirectToSubcontracting(this.fk_visitor_by_visit)
          .subscribe(
            (result: TransactionResult<boolean>) => {
              this.loading = false;
              if (result.success) {
                this.Alert("Success", "MYAPPROVALS.VISIT_REDIRECTED");
                this.GetRequestByUser();
              } else {
                this.loading = false;
                this.Alert("Error", "MYAPPROVALS.Failed_to_redirect");
              }
            },
            (error: any) => { this.ErrorAlert(error); this.loading = false; }
          );
      });
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('MYAPPROVALS.Must_select_request'),
        shown: true
      });
    }
  }

  ChangeStatus(item: IMyApprovals){
    let found = false;
    const index: number = this.listPKVisitByVisitors.indexOf(item.pkvisitbyvisitor);
    if (index !== -1) {
        this.listPKVisitByVisitors.splice(index, 1);
      found = true;
      
      let hasSuppliers = true;

      this.listPKVisitByVisitors.forEach(PKVisitByVisitors => {
        this.listData.forEach(element => {
          if (element.pkvisitbyvisitor == PKVisitByVisitors && element.visittype != "Suppliers") {
            hasSuppliers = false;
          }
        });
      });

      if (hasSuppliers) {
        $("button-custome").find("button.btn.btn-secondary").prop('disabled', false);
      }
    }    
    if (!found) {
      this.listPKVisitByVisitors.push(item.pkvisitbyvisitor);

      let isNotSupplier = this.listData.filter(element => element.pkvisitbyvisitor == item.pkvisitbyvisitor)[0];

      if (isNotSupplier.visittype != "Suppliers") {
        $("button-custome").find("button.btn.btn-secondary").prop('disabled', true);
      }

      if (isNotSupplier.visittype == "Suppliers" && isNotSupplier.approverarea != "MRO") {
        $("button-custome").find("button.btn.btn-secondary").prop('disabled', true);
      }
    }
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }
}
